import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSocket } from "../../src/pages/chatWindow/contexts/SocketContext";
import Auth from "../utils/AuthUtils";
import axios from "../api/axiosinstance";
import { useRef } from "react";
function Header({ sidebarOpen, setSidebarOpen }) {
  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const [animateBell, setAnimateBell] = useState(false);
  const audioRef = useRef(null);
  const audioUnlocked = useRef(false);
  const socket = useSocket();
  const navigate = useNavigate();

  const currentUserId = Auth.getUserDetails("id");

  const fetchNotifications = async () => {
    try {
      const res = await axios.get("/notifications");
      setNotifications(res.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchUnreadCount = async () => {
    try {
      const res = await axios.get("/notifications/unread-count");
      setNotificationCount(res.count);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchNotifications();
    fetchUnreadCount();
  }, []);

  /* ===============================
      REAL TIME NOTIFICATION
  =============================== */

  useEffect(() => {
    if (!socket) return;

    const handleNewNotification = (data) => {

       console.log("🔔 LIVE NOTIFICATION RECEIVED:", data);
      // 🔊 SOUND
      try {
        if (audioRef.current && audioUnlocked.current) {
          audioRef.current.currentTime = 0;

          audioRef.current.play().catch((err) => {
            console.log("Audio blocked:", err);
          });
        }
      } catch (err) {
        console.log("Sound error:", err);
      }
      setNotificationCount((prev) => prev + 1);

      setAnimateBell(true);

      setTimeout(() => {
        setAnimateBell(false);
      }, 2000);

      setNotifications((prev) => [data, ...prev]);
    };

    socket.off("new_notification");
    socket.on("new_notification", handleNewNotification);

    return () => {
      socket.off("new_notification", handleNewNotification);
    };
  }, [socket]);

  const handleLogout = (e) => {
    e.preventDefault();
    sessionStorage.clear();
    navigate("/", { replace: true });
  };

  useEffect(() => {
    audioRef.current = new Audio("/notification.mp3");

    audioRef.current.preload = "auto";

    audioRef.current.volume = 0.7;

    const unlockAudio = async () => {
      try {
        await audioRef.current.play();

        audioRef.current.pause();

        audioRef.current.currentTime = 0;

        audioUnlocked.current = true;

        console.log("🔊 Audio unlocked");
      } catch (err) {
        console.log("Unlock failed:", err);
      }

      window.removeEventListener("click", unlockAudio);
    };

    window.addEventListener("click", unlockAudio);

    return () => {
      window.removeEventListener("click", unlockAudio);
    };
  }, []);

  return (
    <>
      <style>
        {`

        /* ====================================
                HEADER
        ==================================== */

        .header{
          display:flex;
          align-items:center;
          justify-content:space-between;
          padding:0 20px;
          background:#fff;
          box-shadow:0 2px 10px rgba(0,0,0,0.04);
        }

        .header-left{
          display:flex;
          align-items:center;
          height:70px;
        }

        .logo img{
          max-height:58px;
          width:auto;
          object-fit:contain;
        }

        .header-user{
          display:flex;
          align-items:center;
        }

        /* ====================================
                NOTIFICATION BELL
        ==================================== */

        .notification-bell-wrapper{
          position:relative;
        }

        .notification-bell{
          width:42px;
          height:42px;
          border-radius:14px;
          background:#ffffff;
          display:flex;
          align-items:center;
          justify-content:center;
          cursor:pointer;
          transition:all .3s ease;
          box-shadow:0 4px 15px rgba(0,0,0,0.08);
          border:1px solid #eef2ff;
        }

        .notification-bell:hover{
          transform:translateY(-2px);
          background:#f5f7ff;
        }

        .notification-bell i{
          font-size:21px;
          color:#5b5bf7;
        }

        /* ====================================
                BELL ANIMATION
        ==================================== */

        .bell-animate{
          animation:shake .6s ease-in-out infinite;
        }

        @keyframes shake{
          0%{transform:rotate(0)}
          25%{transform:rotate(15deg)}
          50%{transform:rotate(-15deg)}
          75%{transform:rotate(10deg)}
          100%{transform:rotate(0)}
        }

        /* ====================================
                BADGE
        ==================================== */

        .notification-badge{
          position:absolute;
          top:-4px;
          right:-4px;
          min-width:20px;
          height:20px;
          border-radius:50%;
          background:#ff3b3b;
          color:#fff;
          display:flex;
          align-items:center;
          justify-content:center;
          font-size:10px;
          font-weight:700;
          border:2px solid #fff;
          animation:pulse 1.5s infinite;
        }

        @keyframes pulse{
          0%{transform:scale(1)}
          50%{transform:scale(1.15)}
          100%{transform:scale(1)}
        }

        /* ====================================
                DROPDOWN
        ==================================== */

        .notification-dropdown-modern{
          width:380px;
          border:none;
          border-radius:20px;
          overflow:hidden;
          padding:0;
          margin-top:14px;
          background:#fff;
          box-shadow:0 15px 45px rgba(0,0,0,0.14);
          animation:dropdownFade .25s ease;
        }

        @keyframes dropdownFade{
          from{
            opacity:0;
            transform:translateY(10px);
          }
          to{
            opacity:1;
            transform:translateY(0);
          }
        }

        /* ====================================
                HEADER
        ==================================== */

        .notification-header{
          padding:18px;
          background:linear-gradient(135deg,#5b5bf7,#7a7aff);
          color:#fff;
        }

        .notification-header-top{
          display:flex;
          align-items:center;
          justify-content:space-between;
        }

        .notification-header h4{
          margin:0;
          font-size:20px;
          font-weight:700;
          color:white;
        }

        .notification-count-chip{
          background:rgba(255,255,255,0.2);
          padding:4px 10px;
          border-radius:30px;
          font-size:12px;
          font-weight:600;
        }

        .notification-subtitle{
          margin-top:5px;
          font-size:13px;
          opacity:.9;
        }

        /* ====================================
                LIST
        ==================================== */

        .notification-scroll{
          max-height:360px;
          overflow-y:auto;
          background:#f8faff;
          padding:8px;
        }

        .notification-scroll::-webkit-scrollbar{
          width:4px;
        }

        .notification-scroll::-webkit-scrollbar-thumb{
          background:#c7d2fe;
          border-radius:20px;
        }

        /* ====================================
                ITEM
        ==================================== */

        .notification-item{
          background:#fff;
          border-radius:16px;
          padding:14px;
          margin-bottom:10px;
          transition:all .25s ease;
          border:1px solid #eef2ff;
          cursor:pointer;
        }

        .notification-item:hover{
          transform:translateY(-2px);
          box-shadow:0 8px 18px rgba(91,91,247,0.10);
          background:#f9faff;
        }

        .notification-flex{
          display:flex;
          align-items:center;
          gap:14px;
        }

        /* ====================================
                LOGO BOX
        ==================================== */

        .notification-logo{
          width:48px;
          height:48px;
          min-width:48px;
          border-radius:14px;
          background:#fff;
          display:flex;
          align-items:center;
          justify-content:center;
          border:1px solid #eef2ff;
          box-shadow:0 4px 10px rgba(0,0,0,0.05);
          overflow:hidden;
        }

        .notification-logo img{
          width:34px;
          height:auto;
          object-fit:contain;
        }

        /* ====================================
                CONTENT
        ==================================== */

        .notification-content{
          flex:1;
        }

        .notification-title-text{
          font-size:14px;
          color:#111827;
          font-weight:500;
          line-height:1.5;
        }

        .notification-title-text b{
          color:#5b5bf7;
        }

        .notification-time{
          display:flex;
          align-items:center;
          gap:5px;
          margin-top:8px;
          font-size:12px;
          color:#6b7280;
        }

        /* ====================================
                EMPTY STATE
        ==================================== */

        .empty-notification{
          padding:50px 20px;
          text-align:center;
        }

        .empty-notification i{
          font-size:50px;
          color:#c7d2fe;
          margin-bottom:12px;
        }

        .empty-notification h5{
          font-size:18px;
          margin-bottom:5px;
          color:#111827;
        }

        .empty-notification p{
          font-size:13px;
          color:#6b7280;
        }

        `}
      </style>

      <div className="header">
        {/* =========================
                LEFT LOGO
        ========================= */}

        <div className="header-left active">
          <button
            className="mobile-menu-btn"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            <i className="ti ti-menu-2"></i>
          </button>

          <Link to="/dashboard" className="logo logo-normal">
            <img src="/assets/img/logo.png" alt="logo" />
          </Link>
        </div>

        {/* =========================
                RIGHT SIDE
        ========================= */}

        <div className="header-user">
          <ul className="nav user-menu">
            {/* =========================
                    NOTIFICATION
            ========================= */}

            <li className="nav-item dropdown nav-item-box">
              <a
                className="nav-link"
                data-bs-toggle="dropdown"
                onClick={async () => {
                  setNotificationCount(0);

                  try {
                    await axios.patch("/notifications/read-all");
                  } catch (err) {
                    console.log(err);
                  }
                }}
              >
                <div className="notification-bell-wrapper">
                  <div
                    className={`notification-bell ${
                      animateBell ? "bell-animate" : ""
                    }`}
                  >
                    <i className="ti ti-bell"></i>
                  </div>

                  {notificationCount > 0 && (
                    <span className="notification-badge">
                      {notificationCount}
                    </span>
                  )}
                </div>
              </a>

              {/* =========================
                      DROPDOWN
              ========================= */}

              <div className="dropdown-menu dropdown-menu-end notification-dropdown-modern">
                {/* HEADER */}

                <div className="notification-header">
                  <div className="notification-header-top">
                    <h4>Notifications</h4>

                    <div className="notification-count-chip">
                      {notificationCount} New
                    </div>
                  </div>

                  <div className="notification-subtitle">
                    Stay updated with recent activity
                  </div>
                </div>

                {/* BODY */}

                <div className="notification-scroll">
                  {notifications.length === 0 ? (
                    <div className="empty-notification">
                      <i className="ti ti-bell-off"></i>

                      <h5>No Notifications</h5>

                      <p>New updates will appear here</p>
                    </div>
                  ) : (
                    notifications.map((n) => (
                      <div
                        key={n._id}
                        className="notification-item"
                        onClick={async () => {
                          try {
                            await axios.patch(`/notifications/${n._id}/read`);
                          } catch (err) {
                            console.log(err);
                          }

                          if (n.leadId) {
                            navigate(`/lead-details/${n.leadId}`);
                          }
                        }}
                      >
                        <div className="notification-flex">
                          {/* LOGO */}

                          <div className="notification-logo">
                            <img src="/assets/img/logo.png" alt="Axesell" />
                          </div>

                          {/* CONTENT */}

                          <div className="notification-content">
                            <div className="notification-title-text">
                              <b>{n.title}</b> {n.message}
                            </div>

                            <div className="notification-time">
                              <i className="ti ti-clock"></i>

                              {new Date(n.createdAt).toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </li>

            {/* =========================
                    USER
            ========================= */}

            <li className="nav-item dropdown has-arrow main-drop">
              <a className="nav-link userset" data-bs-toggle="dropdown">
                <span className="user-info">
                  <span className="user-letter">
                    <img
                      src="/assets/img/profiles/avatar-20.jpg"
                      alt="Profile"
                    />
                  </span>
                </span>
              </a>

              <div className="dropdown-menu menu-drop-user">
                <div className="profilename">
                  <Link to="/dashboard" className="dropdown-item">
                    <i className="ti ti-layout-2" /> Dashboard
                  </Link>

                  <a href="#" className="dropdown-item" onClick={handleLogout}>
                    <i className="ti ti-lock" /> Logout
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Header;
